"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { leaveManagement } from "@/content/agent-use-cases/leave-management";

export default function LeaveManagementUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={leaveManagement} locale={locale} />;
}
